import styled from '@emotion/styled'
import { FadeInUp } from 'app/components/Common/Animation/FadeInUp'
import { FlexBox } from 'app/components/Layout/FlexBox'
import React, { memo, useEffect, useState } from 'react'

export interface Props {
  price: string
}

export const Price = memo(function Price({ price }: Props) {
  if (!price) {
    return null
  }

  const [loading, setloading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setloading(false)
    }, 2000)
  }, [])

  return (
    <FadeInUp delay={loading ? 2.1 : 0}>
      <Container dial={5} inline row>
        {price}
      </Container>
    </FadeInUp>
  )
})

const Container = styled(FlexBox)`
  color: ${({ theme }) => theme.colors.variants.primaryDark};
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.15em;
  line-height: 1rem;
  margin-top: 1.875rem;
  padding-left: 3.125rem;
  position: relative;
  text-transform: uppercase;
  &:before {
    content: '';
    width: 2.25rem;
    height: 0.0625rem;
    background: ${({ theme }) => theme.colors.variants.neutralLight2};
    position: absolute;
    top: 0.5rem;
    left: 0;
  }

  @media (max-width: 1199px) {
    padding-left: 2.75rem;
    &:before {
      width: 1.875rem;
    }
  }
`
